import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '仪表盘', icon: 'dashboard'}
    },
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'badge',
        name: 'badge',
        component: () => import('@/views/pms/badge/index'),
        meta: {title: '袖章管理', icon: 'product-cate'}
      },
            {
        path: 'number',
        name: 'number',
        component: () => import('@/views/pms/number/index'),
        meta: {title: '号码牌管理', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },

      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },

      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      // {
      //   path: 'orderSetting',
      //   name: 'orderSetting',
      //   component: () => import('@/views/oms/order/setting'),
      //   meta: {title: '订单设置', icon: 'order-setting'}
      // },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退款申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },

  {
  path: '/user1',
  component: Layout,
  redirect: 'user', 
  meta: { title: '用户管理', icon: 'sms' },
  children: [
    {
      path: 'userInfo', 
      component: () => import('@/views/user/index.vue'),
      name: 'userInfo',
      meta: { title: '用户信息', icon: 'sms' }
    }
  ]
},
  {
  path: '/language',
  component: Layout,
  redirect: 'language', 
  meta: { title: '国际化', icon: 'sms' },
  children: [
    {
      path: 'badge-language', 
      component: () => import('@/views/language/badgeLanguage/index.vue'),
      name: 'LanguageBadge',
      meta: { title: '袖章', icon: 'sms' }
    },
        {
      path: 'productLanguage', 
      component: () => import('@/views/language/productLanguage/index.vue'),
      name: 'LanguageOrder',
      meta: { title: '商品', icon: 'sms' }
    }
  ]
},
  {
  path: '/mq',
  component: Layout,
  redirect: 'language', 
  meta: { title: 'MQ消息管理', icon: 'sms' },
  children: [
    {
      path: 'product-Message', 
      component: () => import('@/views/mqMessage/productMessage/index.vue'),
      name: 'productMessage',
      meta: { title: '商品模块', icon: 'sms' }
    },
     {
      path: 'order-Message', 
      component: () => import('@/views/mqMessage/orderMessage/index.vue'),
      name: 'orderMessage',
      meta: { title: '订单模块', icon: 'sms' }
    },
  ]
},  {
  path: '/imMessage',
  component: Layout,
  redirect: 'language', 
  meta: { title: 'IM消息管理', icon: 'sms' },
  children: [
    {
      path: 'im-Message', 
      component: () => import('@/views/imMessage/index.vue'),
      name: 'imMessage',
      meta: { title: '聊天', icon: 'sms' }
    },
  ]
},
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js